import React from 'react';
import { ContentSection } from '@vwfs-bronson/bronson-react';
import { HeroImage } from '@cp-shared-19/frontend-ui';
import { SimplePage, SimpleTeaser, SimplePageContent } from '@cp-mx/common';

export const CookiePolicyTeaserUI: React.FC<{ teaser?: SimpleTeaser }> = ({ teaser }) =>
    teaser ? (
        <HeroImage
            title={teaser.title}
            imageUrl={teaser.imageUrl}
            shallow={true}
            inverted={!!teaser.isInverted}
            subTitle={teaser.subTitle}
        />
    ) : null;

export const CookiePolicyContent: React.FC<{ content?: SimplePageContent }> = ({ content }) =>
    content ? (
        <>
            {Object.keys(content).map((section: string) => (
                <ContentSection key={section} pageWrapSize="medium">
                    <div dangerouslySetInnerHTML={{ __html: content[section] }} />
                </ContentSection>
            ))}
        </>
    ) : null;

export const CookiePolicyUi: React.FC<{ cookiePolicy?: SimplePage }> = ({ cookiePolicy }) =>
    cookiePolicy ? (
        <>
            <CookiePolicyTeaserUI teaser={cookiePolicy.teaser} />
            <CookiePolicyContent content={cookiePolicy.content} />
        </>
    ) : null;
